/**
 * Format number for display (e.g., views count)
 * @param {number} num - Number to format
 * @returns {string} Formatted number
 */
export const formatNumber = (num) => {
    if (!num) return '0';
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
};

/**
 * Format duration from seconds to MM:SS or HH:MM:SS
 * @param {number} seconds - Duration in seconds
 * @returns {string} Formatted duration
 */
export const formatDuration = (seconds) => {
    if (!seconds || seconds < 0) return '0:00';

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    return `${minutes}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Get cover image URL for a drama
 * @param {object} drama - Drama object
 * @returns {string} Cover image URL
 */
export const getCoverImageUrl = (drama) => {
    if (!drama) return '';

    // Priority order: coverWap, coverPc, cover, or construct from bookId
    if (drama.coverWap) return drama.coverWap;
    if (drama.coverPc) return drama.coverPc;
    if (drama.cover) return drama.cover;

    // Fallback: construct from bookId
    if (drama.bookId || drama.id) {
        const id = drama.bookId || drama.id;
        return `https://nchapter.dramaboxdb.com/data/cppartner/4x1/41x0/410x0/${id}/${id}.jpg`;
    }

    return '';
};

/**
 * Detect if device is mobile
 * @returns {boolean}
 */
export const isMobile = () => {
    return window.innerWidth <= 768;
};

/**
 * Debounce function
 * @param {Function} func - Function to debounce
 * @param {number} wait - Milliseconds to wait
 * @returns {Function} Debounced function
 */
export const debounce = (func, wait = 300) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

/**
 * Scroll to top of page smoothly
 */
export const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

/**
 * Update page title
 * @param {string} title - New title
 */
export const updatePageTitle = (title) => {
    if (title) {
        document.title = title;
    }
};

/**
 * Update meta description
 * @param {string} description - New description
 */
export const updateMetaDescription = (description) => {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription && description) {
        metaDescription.setAttribute('content', description);
    }
};
